export default __webpack_public_path__ + "static/media/iconLocation.70403517.png";